import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

function CheckConnectorVersion({ version, versionMinimum }) {
  return (
    <Card id="wrong_connector_version">
      <Card.Header>Mise à jour du connecteur requise</Card.Header>
      <Card.Body>
        <Alert variant="info" className="d-flex align-items-center justify-content-between">
          <span>
            <i className="la la-info-circle mr-1" />
            En attente de la mise à jour du connecteur
          </span>
          <Spinner animation="border" size="sm" />
        </Alert>
        <Card.Text>
          Cette application nécessite l&apos;installation préalable de la bonne version du composant DmpConnect-JS2 :
          <ul className="mt-1">
            <li>
              Version installée&nbsp;:
              {' '}
              {version}
            </li>
            <li>
              Version requise&nbsp;:
              {' '}
              {versionMinimum}
            </li>
          </ul>
        </Card.Text>
        <Card.Text>
          Veuillez cliquer sur le bouton ci-dessous pour être redirigé vers la page de téléchargement.
        </Card.Text>
        <div className="text-center">
          <Button
            size="lg"
            variant="primary"
            className="mx-auto"
            href={`https://www.icanopee.fr/telechargement-du-connecteur-dmpconnect-js2/?version=${versionMinimum}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Télécharger
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

CheckConnectorVersion.propTypes = {
  version: PropTypes.string.isRequired,
  versionMinimum: PropTypes.string.isRequired,
};

export default CheckConnectorVersion;
